import {
  Button,
  Dialog as MuiDialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { getHighlightRGBA } from '../../../../Highlighting/utils/utils';
import FormContent from '../FormContent';
import { useAnnotationDialogsContext } from '../../../AnnotationDialogsContext';
import { useAnnotationFormContext } from '../FormContext';

export default function Dialog() {
  const {
    selectedAnnotation: annotation,
    closeEditDialog,
    isEditDialogOpen,
  } = useAnnotationDialogsContext();
  const { formData, saveAnnotation } = useAnnotationFormContext();

  return (
    <MuiDialog
      open={isEditDialogOpen}
      onClose={closeEditDialog}
      maxWidth='sm'
      fullWidth
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            saveAnnotation();
            closeEditDialog();
          },
        },
      }}
    >
      {isEditDialogOpen && (
        <>
          <DialogTitle>Muokkaa merkintä</DialogTitle>
          <DialogContent
            sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}
          >
            <DialogContentText
              color='text.primary'
              sx={{
                borderLeft: `4px solid ${getHighlightRGBA(formData.highlightColor)}`,
                paddingLeft: 1.5,
              }}
            >
              {annotation?.text.content}
            </DialogContentText>
            <FormContent />
          </DialogContent>
          <DialogActions>
            <Button
              type='submit'
              variant='contained'
              onClick={() => saveAnnotation()}
            >
              Tallenna
            </Button>
            <Button onClick={closeEditDialog} variant='outlined'>
              Peruuta
            </Button>
          </DialogActions>
        </>
      )}
    </MuiDialog>
  );
}
